import React, { ReactElement } from 'react';
import { FieldTemplateProps } from '@rjsf/utils';
import {
  description,
  label,
  shouldUseContainer,
  title,
  widget,
} from '../utils';
import Container from '@amzn/awsui-components-react-v3/polaris/container';
import Header from '@amzn/awsui-components-react-v3/polaris/header';
import { FormField } from '@amzn/awsui-components-react-v3';
import WrapIfAdditionalTemplate from './WrapIfAdditionalTemplate';

export default function FieldTemplate(props: FieldTemplateProps): ReactElement {
  if (props.hidden) {
    return <></>;
  }
  return (
    <WrapIfAdditionalTemplate {...props}>
      {props.children}
    </WrapIfAdditionalTemplate>
  );
}
